import React from 'react'

const IntegratedESG = () => {
  return (
    <div>
      
    </div>
  )
}

export default IntegratedESG
